module.exports = __webpack_public_path__ + "img/hipercard.0c9f8bbf.svg";